import { render, staticRenderFns } from "./sellers.vue?vue&type=template&id=6a81b307&scoped=true"
import script from "./sellers.vue?vue&type=script&lang=js"
export * from "./sellers.vue?vue&type=script&lang=js"
import style0 from "./sellers.vue?vue&type=style&index=0&id=6a81b307&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a81b307",
  null
  
)

export default component.exports